


























import _ from 'lodash'
import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

interface DeliveryTimePriod {
  code: string
  label: string
}

interface DeliveryPlan {
  time?: {
    code: string
  }
}

@Component
export default class TimeSlotSelect extends Vue {
  @Prop({ required: true })
  deliveryPlan: DeliveryPlan

  @Prop({ required: true })
  list: DeliveryTimePriod[]

  @Prop({ default: '0' })
  value: string

  get canSpecifyTemePeriod() {
    // https://everforth.backlog.jp/view/PJ_MYCOLOR-1176
    return _.get(this.deliveryPlan, 'time.code') !== '0'
  }

  onInput(event) {
    this.$emit('input', event.target.value)
  }
  onChange(event) {
    this.$emit('change', event.target.value)
  }
}
